"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageItems = void 0;
var LocalStorageItems;
(function (LocalStorageItems) {
    LocalStorageItems["JOB_QUEUE_CHECKOUT"] = "job_queueCheckout";
    LocalStorageItems["CHECKOUT"] = "data_checkout";
    LocalStorageItems["PAYMENT"] = "data_payment";
})(LocalStorageItems = exports.LocalStorageItems || (exports.LocalStorageItems = {}));
//# sourceMappingURL=types.js.map